import { useCallback, useEffect, useState } from 'react';
import { App, Button, Input, Space, Table, Tag } from 'antd';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { AdminPermissionVo, listPermissions } from '@apis/admin';

const TYPE_COLORS: Record<string, string> = {
  menu: 'blue',
  api: 'green',
  button: 'purple',
};

export default function PermissionTab() {
  const { message } = App.useApp();
  const [data, setData] = useState<AdminPermissionVo[]>([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setData(await listPermissions());
    } catch (e: any) {
      message.error(e?.message || '加载失败');
    } finally {
      setLoading(false);
    }
  }, [message]);

  useEffect(() => { load(); }, [load]);

  const filtered = keyword
    ? data.filter((p) =>
        [p.code, p.name, p.parentCode, p.description]
          .filter(Boolean)
          .some((s) => (s as string).toLowerCase().includes(keyword.toLowerCase())),
      )
    : data;

  const columns: ColumnsType<AdminPermissionVo> = [
    { title: 'ID', dataIndex: 'id', width: 70 },
    {
      title: '类型',
      dataIndex: 'type',
      width: 90,
      render: (t: string) => <Tag color={TYPE_COLORS[t] || 'default'}>{t}</Tag>,
    },
    { title: '编码', dataIndex: 'code', width: 220 },
    { title: '名称', dataIndex: 'name', width: 180 },
    { title: '父节点', dataIndex: 'parentCode', width: 180 },
    { title: '说明', dataIndex: 'description', ellipsis: true },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 12 }}>
        <Input
          placeholder="搜索 code / name / parent"
          prefix={<SearchOutlined />}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          allowClear
          style={{ width: 280 }}
        />
        <Button icon={<ReloadOutlined />} onClick={() => load()}>刷新</Button>
      </Space>

      <Table<AdminPermissionVo>
        rowKey="id"
        columns={columns}
        dataSource={filtered}
        loading={loading}
        pagination={{ pageSize: 30 }}
      />

      <div style={{ marginTop: 12, color: '#888', fontSize: 12 }}>
        权限点维护通过数据库迁移落地（``db/init.sql`` / ``db/update.sql``），后台仅作只读浏览。
      </div>
    </div>
  );
}
